import { useCompany } from 'src/core/modules/app/hooks/useCompany';
import {
  useGetWiseKycStatus,
  useIsUkInternationalWireTransferEnabled,
} from 'src/core/modules/invoices/transfer/hooks';

export const useIsUkKycRejected = (enabled: boolean = true): boolean => {
  const company = useCompany();

  const isUkInternationalWireTransferEnabled =
    useIsUkInternationalWireTransferEnabled();

  const { data: kycStatus } = useGetWiseKycStatus({
    companyId: company.id,
    enabled: enabled && isUkInternationalWireTransferEnabled,
  });

  return kycStatus === 'REJECTED';
};
